import Vue from 'vue'
import Vuex from 'vuex'
import test from './modules/default'
import user from "./modules/user"
import credentials from "./modules/credentials"
import application from "./modules/application"
import toast from "./modules/toast"
import confidentiality from "./modules/confidentiality"
import adminApp from "./modules/adminApp";
import messagerie from "./modules/messagerie";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    test: test,
    credentials: credentials,
    user: user,
    application: application,
    toast: toast,
    confidentiality: confidentiality,
    adminApp: adminApp,
    messagerie: messagerie
  },
  strict: true
});



// WEBPACK FOOTER //
// ./src/store/index.js